import { BriefingBoard } from './briefing-board';
import type { SafetyBoardAuthority } from '../safety-board/model';
import { SafetyBoardSiteContext } from '../safety-board/site-context';

export function HomeBriefing({
  authority,
  owner,
  onSettled,
  siteId,
}: {
  authority: SafetyBoardAuthority;
  owner: { uid: string; contractorId: string | null };
  onSettled?: () => void;
  siteId: string | null;
}) {
  return (
    <SafetyBoardSiteContext.Provider key={JSON.stringify([siteId, owner.uid, owner.contractorId])} value={siteId}><div className="home-briefing">
      <BriefingBoard authority={authority} owner={owner} onSettled={onSettled} compactRows={3}/>
    </div></SafetyBoardSiteContext.Provider>
  );
}
